module.exports = __webpack_public_path__ + "img/dizhi-check-1.7164c71f.png";